<template>
	<div class="sign">
		<header>
			<h1>
				<router-link to="/mine">
					<v-icon name="chevron-left" class="set_2"></v-icon>
				</router-link>
				<p class="set_1">问答</p>
			</h1>
		</header>
		<div class="up">
			<p class="title">{{up.title}}</p>
			<p class="titler">阅读量	: <span>{{up.readnum}}</span></p>
			<div class="titlerc">
				<span class="dian"></span>
				<p class="titwd">{{up.title}}</p>
			</div>
			<div class="atz">
				<v-icon name="smile" class="at"></v-icon>
			</div>
			<p class="tnat" v-html="up.content">{{up.content}}</p>
			<div class="timg" v-html="up.img">
				{{up.img}}
			</div>
			<div class="xt">
				<span class="qq">Q</span>
				<span class="qa">&</span>
				<span class="aa">A</span>
				<p class="xian"></p>
			</div>
			<div class="navxy">
				<span class="navxyc"></span>
				<p class="naccp">音频解读</p>
			</div>
			<!--  -->
			<div class="navwd" v-for="itm in down">
				<p class="wda">小读者 :</p>
				<p class="wdb">{{itm.n_msg}}</p>
				<p class="wdc">{{up.n_name}} :</p>
				<div class="wdd" @click="audioc(itm.n_upload)">
					<img :src="'http://ts.winwulian.com/uploads/ask/'+up.pic" class="wde">
					<p class="wdf"> 「 点击图片，收听回答 」</p>
				</div>
			</div>
			<!--audio http://ts.winwulian.com/upload/  -->
		</div>
		<audio id="audioc" src="" ref="audio"></audio>
	</div>
</template>
<script>
import $ from 'jquery';
import { CURL } from "../../lib/url.js";
export default {
	data(){
		return{
			up:[],
			down:[],
			p:[],
			q:[],
			c:[],
		}
	},
	mounted(){
		this.getAjax()
	},
	methods:{
		audioc:function(e){
			
			var i = CURL+'/upload/'+e
			$('#audioc').attr('src', i)
			this.$refs.audio.play()
		},
		getAjax:function () {
		//var openid=localStorage.getItem("openid");
		var successCallback =  (response) => {
			console.log('success')
			// console.log(response)
			this.up = response.ask[0]
			this.down = response.wenda
			this.p = this.up.content
		}
		var errorCallback =  (response) => {
			console.log('error')
		}
		this.$http.get(CURL+'/portal/All/getwenda',{
		        data:{}
		      }).then(successCallback,errorCallback);
		},
	},
}
</script>
<style lang="scss" scoped>
.wde{
	width: 22%;
	margin-bottom: 15px;
	margin-top: 15px;
}
.wdd{
	margin: 5px;
	height: auto;
	padding: 3px;
	color: #555;
	text-align: center;	
}
.wdb{
	margin: 5px;
	height: auto;
	padding: 3px;
	color: #555;
}
.wda,.wdc{
	width: 20%;
	background-color: #f9a159;
	margin: 5px;
	height: auto;
	padding: 3px;
	color: #ffffff;
}
.navwd{
	border: #f9a159 solid 2px;
	width: 95%;
	margin: 0 auto;
	height: 220px;
	margin-bottom: 20px;
}
.naccp{
	color: #FFFFFF;
	float: left;
	margin: 5px 0 5px 0;
}
.navxyc{
	margin: 6px 10px 4px 5px;
	display: block;
	width: 15px;
	height: 15px;
	border: #FFFFFF solid 2px;
	border-radius: 50%;
	background-color:  #f9a159;
	float: left;
}
.navxy{
	width: 27%;
	margin: 0 auto;
	text-align: center;
	height: 27px;
	background-color:  #f9a159;
	border-radius: 5px;
	margin-bottom: 20px;
}
.xian{
	width: 60%;
	height: 1px;
	background-color: #f9a159;
	position: relative;
	top: -10px;
	left: 34px;
}
.aa{
	position: relative;
	color: #f9a159;
	top: 9px;
	left: -9px;
	font-size: 15px;
}
.qa{
	position: relative;
	color: #f9a159;
	top: 5px;
	left: -4px;
}
.qq{
	position: relative;
	font-size: 19px;
	color: #f9a159;
	top: 0;
	left: 0;
}
.xt{
	width: 100%;
	margin-bottom: 15px;
}
.imgc{
	width: 80%;
	margin: 10px 10% 10px 10%;
}
.timg{
	background-color: #f9a159;
	width: 100%;
	margin-bottom: 15px;
}
.tnat{
	color: #555;
	margin-bottom: 15px;
}
.atz{
	width: 100%;
	text-align: center;
	margin: 15px 0 15px 0;
}
.at{
	color: #f9a159;
}
.titwd{
	text-align: center;
	margin-top: 39px;
	color: #FFFFFF;
}
.dian{
	display: block;
	position: relative;
	width: 7px;
	height: 7px;
	top: 27px;
	left: 18px;
	background-color: #FFFFFF;
	border-radius: 50%;
}
.titlerc{
	background-color: #f9a159;
	width: 100%;
	height: 100px;
	border-radius: 3px;
}
.titler{
	text-align: right;
	padding-right: 20px;
	font-size: 12px;
	color: #777;
	margin-bottom: 20px;
}
.title{
	height: 30px;
	line-height: 30px;
	width: 100%;
	text-align: center;
	font-size: 16px;
	color: #333;
}
/**/
.tc_navx{
	background-color: #00a8d9;
	border-radius: 5px;
	padding: 10px 20px 10px 20px;
}
.tc_nav{
	display: none;
	position: fixed;
	margin-left: 20%;
	text-align: center;
	width: 60%;
	color: #ffffff;
	font-size: 15px;
	bottom: 70%;
}
.upbutton{
	float: left;
	width: 80%;
	padding:10px 0 10px 0;
	background-color: #00a8d9;
	color: #FFFFFF;
	border-radius: 3px;
	margin: 77px 10% 77px 10%;
}
.upinput{
	background-color: initial;
	float: right;
	width: 80%;
	text-align: left;
}
.upselect{
	float: right;
	margin-top: 10px;
}
.upli{
	float: left;
	width: 100%;
	padding-right: 5%;
	padding-left: 5%;
	height: 55px;
	line-height: 55px;
	border-bottom: #777 solid 1px;
}
.upul{
	margin-top: .1rem;
	float: left;
	width: 100%;
}
.up{
	margin: 0 2.5% 0 2.5%;
	float: left;
	margin-top: .4rem;
	width: 95%;
	background-color: #FFFFFF;
}
.sign{
	width: 100%;
}
header{
	position: fixed;
	height: .4rem;
	background:url(../../img/ss.png);
	background-size:100% 100%;
	background-repeat: no-repeat;
	width: 100%;
    z-index: 99999999;
}
.set_1{
	text-align: center;
    float: left;
    width: 85%;
    height: .4rem;
    font-weight: 600;
    color: #FFFFFF;
    font-size: 19px;
    line-height:.4rem;
}
.set_2{
	float: left;
	margin-top: 13px;
	margin-left: 3%;
	width: 5%;
	color: #FFFFFF;
}
</style>


// WEBPACK FOOTER //
// src/components/activity/sign.vue